"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var CircularProgress_1 = __importDefault(require("../CircularProgress"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette;
    return ({
        container: {
            backgroundColor: palette.action.disabledBackground,
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    });
});
var MultiSelectProgress = function () {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(CircularProgress_1.default, null)));
};
exports.default = MultiSelectProgress;
